import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BellRing, ChevronDown, Play } from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import { UrgencyPanel } from './UrgencyPanel';

// Mobile only (#118): the 13:00 follow-up as a compact bar above the work queue,
// so the tasks are not pushed below the long panel. The full panel opens on demand;
// the tour targets the bar while it is closed, and running the check opens it.
export const UrgencyBar = ({ sim, onSelect }) => {
  const [open, setOpen] = useState(false);
  const { phase, clock, runCheck } = sim;

  return (
    <div className="space-y-2">
      <Card className="p-3 space-y-2" data-tour={open ? undefined : 'urgency-panel'}>
        <div className="flex items-center gap-2">
          <BellRing className="h-4 w-4 text-primary shrink-0" aria-hidden="true" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold">{t('arrivals.urgency.title')} · {clock}</div>
            <div className="text-xs text-muted-foreground">{t(`arrivals.urgency.bar.${phase}`)}</div>
          </div>
          <Button size="sm" variant="ghost" className="h-8 px-2" aria-expanded={open} aria-label={t('arrivals.urgency.barToggle')} onClick={() => setOpen(o => !o)}>
            <ChevronDown className={cn('h-4 w-4 transition-transform', open && 'rotate-180')} />
          </Button>
        </div>
        {phase === 'idle' && (
          <Button size="sm" className="w-full h-9 gap-1" data-tour="urgency-run" onClick={() => { runCheck(); setOpen(true); }}>
            <Play className="h-3.5 w-3.5" /> {t('arrivals.urgency.run')}
          </Button>
        )}
      </Card>
      {open && <UrgencyPanel sim={sim} onSelect={onSelect} />}
    </div>
  );
};
